module.exports = __webpack_public_path__ + "static/img/wtg.5d292bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wtg.png
// module id = WNWJ
// module chunks = 1